import { ArrowRight } from "lucide-react";
import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer className="site-footer">
    <div className="container">
      <div className="footer-wordmark" aria-hidden="true">SHERAWALI</div>
      <div className="footer-grid">
        <div className="footer-brand-col">
          <a className="brand brand-light" data-testid="footer-brand-link" href="#home">
            <LogoMark />
            <span className="brand-text">JAY MAA SHERAWALI<small>TRANSPORT · PACKERS &amp; MOVERS · CAR CARRIERS</small></span>
          </a>
          <p>Making every move feel<br />a little more like home.</p>
        </div>
        <div>
          <h4>Explore</h4>
          <a data-testid="footer-services-link" href="#services">Our services</a>
          <a data-testid="footer-reviews-link" href="#reviews">Customer stories</a>
          <a data-testid="footer-contact-link" href="#contact">Contact us</a>
        </div>
        <div>
          <h4>Get in touch</h4>
          <a data-testid="footer-phone-link" href="tel:+919135667888">91356 67888</a>
          <a data-testid="footer-phone-link-secondary" href="tel:+919135668888">91356 68888</a>
          <span>New Bypass Road, New Zero Mile<br />Patna, Bihar 800030</span>
        </div>
        <div className="footer-cta">
          <p>Ready when you are.</p>
          <a data-testid="footer-quote-button" className="btn btn-gold" href="#quote">Get a free quote <ArrowRight size={15} /></a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 Jay Maa Sherawali Transport, Packers and Movers &amp; Car Carriers</span>
        <a href="/admin" data-testid="footer-admin-link">Owner login</a>
      </div>
    </div>
  </footer>
);
